import * as fp from "lodash/fp";
import * as React from 'react';

export default fp.curry( (validate, Component, NoDataComponent) => {
    return class extends React.Component<any, any> {
        render() {
            return validate(this.props) ?
                <Component {...this.props}/> :
                <NoDataComponent {...this.props}/>
        }
    }
})



// WEBPACK FOOTER //
// ./resources/modules/utilities/noData.tsx